const data = [
   // { name: "RESUMO GERAL", route: "/resumo-geral" },
    { name: "MINHA CONTA", route: "/minha-conta", profiles: [1] },
    { name: "MINHA CONTA", route: "/conta-procurador", profiles: [4] },
    { name: "RESUMO GERAL", route: "/resumo", profiles: [1] },
    { name: "PRIVACIDADE", route: "/privacidade", profiles: [1, 4] },
    { name: "CREDORES", route: "/credores-procurador", profiles: [4] },
    { name: "HABILITAÇÕES / DIVERGÊNCIAS", route: "/habilitacoes-divergencias", profiles: [1, 4], module: "site.habdiv.create" },
    { name: "ANÁLISE DE OFÍCIO", route: "/analise-oficio", profiles: [1, 4], module: "site.official_analysis" },
    { name: "REVISÃO DE CRÉDITO", route: "/revisao-credito", profiles: [1, 4] },
    { name: "MINHAS IMPUGNAÇÕES", route: "/minhas-impugnacoes", profiles: [1, 4], module: "site.proceedings" },
    { name: "ADESÃO AO PLANO", route: "/plano-adesao", profiles: [4], module: "site.plan_adherence" },
    { name: "ADESÃO AO PLANO", route: "/adesao-plano", profiles: [1], module: "site.plan_adherence" },
    { name: "CERTIDÃO DE CRÉDITO", route: "/certidao-credito", profiles: [1], module: "site.chc.request" },
    { name: "CERTIDÃO DE CRÉDITO", route: "/certidao-credito-procurador", profiles: [4], module: "site.chc.request" },
    { name: "COMPROVANTES INFORMADOS", route: "/comprovantes-informados", profiles: [1, 4], module: "site.payment_proofs" },
    { name: "MODELOS DE DOCUMENTOS", route: "/modelos-documentos", profiles: [1], module: "site.document_models" },
   // { name: "ASSEMBLEIA DE CREDORES", route: "/assembleia-credores" },
    { name: "CENTRAL DE DOCUMENTOS", route: "/central-documentos", profiles: [1], module: "site.documents_center" },
    //{ name: "ASSINATURA DE DOCUMENTOS", route: "/assinatura-documentos", profiles: [1] },
];

//allowedProfiles: [1] => só permite acesso do credor
//allowedProfiles: [4] => só permite acesso do procurador
//allowedProfiles: [1, 4] => permite acesso de ambos
//module: chave em Módulos e prazos (backoffice); fechado e oculto => some do menu

export default [...data];
